<template>
  <b-overlay
    :show="__isOnLoad"
    variant="dark"
    rounded
    opacity="0.70"
    spinner-variant="primary"
    spinner-small
    style="float: left; width: 100%;"
  >
  
    <div :class="styleSublisteMode+isCurrent(index === __idxOnEdition)" v-for="(item, index) in __list" :key="index">
      <button type="button" class="subPreview" @click= "showMenu = ((showMenu === index) ? -1 : index)">
        <span class="optionStateRail" :class="item.isActive == true ? 'optionStateRail-on' : 'optionStateRail-off'"></span>
        <span>{{ item.name}}</span>
      </button>

      <div class="subMenu" v-if="showMenu === index">
        <ico-btn size="p" type="simple" icone="gear-fill" :cb="()=>{dispatchEdit(item._id)}"></ico-btn>
        <ico-btn size="p" type="toggleOn" custom="orange" icone="eye-slash-fill" v-if=" item.isActive == true" :cb="()=>{dispatchDesactive(item._id)}"></ico-btn>
        <ico-btn size="p" type="toggleOff" icone="eye-fill" v-if=" item.isActive == false" :cb="()=>{dispatchActive(item._id)}"></ico-btn>
        <ico-btn size="p" type="warning" icone="trash" :cb="()=>{dispatchDelete(item._id)}" v-if="__editMode == false"></ico-btn>
        <ico-btn size='p' type="simple" icone="list-stars" :cb="()=>{showSub(item._id)}" v-if="__type == 'EXT_DD'"></ico-btn>
      </div>
    </div>
  </b-overlay>
</template>
<script>

export default {
  components: {
  },
  props: {
    __idxOnEdition: {
      type: Number,
      default: () => {
        return -1;
      },
    },
    __isOnLoad: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    __list: {
      type: Array,
      default: () => {
        return [];
      },
    },
    __editMode: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    __type: {
      type: String,
      default: () => {
        return 'DD';
      },
    },
  },
  
  data() {
    return {
      showMenu: -1,
    };
  },
  methods: {
    showSub(id) {
      this.$parent.showSub(id);
    },

    isCurrent(current) {
      return current && this.__editMode ? ' actif' : '';
    },

    toggleMenu(index) {
      if(this.showMenu != index ){this.showMenu = index} else {this.showMenu =-1}
    },

    dispatchEdit(idx) {
      this.$parent.editAction(idx);
    },

    dispatchActive(idx) {
      this.$parent.toggleActivateAction(idx,1);
    },

    dispatchDesactive(idx) {
      this.$parent.toggleActivateAction(idx,0);
    },

    dispatchDelete(idx) {
      this.$bvModal.msgBoxConfirm('Veuillez confirmer la suppression.', {
        title: 'Confirmation',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Confirmer',
        cancelTitle: 'Annuler',
        footerClass: 'p-2',
        hideHeaderClose: true,
        centered: false
      })
        .then(value => {
          if(value) {
            this.$parent.deleteAction(idx);
          }
        })
    },

    dispatchAdd() {
      this.$parent.addAction();
    },

  },

  computed: {
    styleSublisteMode() {
      return (this.__idxOnEdition !== -1) ? 'sublisteModeFull' : 'sublisteMode';
    },
  },

  watch: {
    __isOnLoad: function () {
    },
  },
};
</script>
<style>
.actif{
  opacity: 1 !important;
}
.sublisteModeFull {
  width: 25%;
    float: left;
    margin-bottom: 10px;
    border-radius: 10px;
    border: dotted 1px #ccc;
    opacity: 0.3;
}
.sublisteModeFull .subMenu {
  width: 60%;
    float: left;
    padding: 5px;
    border-radius: 10px;
}
.sublisteModeFull .subPreview {
  width: 40%;
  float: left;
  padding: 10px;
  border-radius: 10px;
}
.sublisteMode {
    width: 25%;
    float: left;
    margin-bottom: 10px;
    border-radius: 10px;
    border: dotted 1px #ccc;
}
.sublisteMode .subMenu {
    width: 60%;
    float: left;
    padding: 5px;
    border-radius: 10px;
}
.sublisteMode .subPreview {
    width: 40%;
    float: left;
    padding: 10px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    gap: 10px;
    appearance: none;
    border: 0;
    background: transparent;
    text-align: left;
    font-family: inherit;
}

.optionStateRail {
  flex: 0 0 auto;
  width: 6px;
  min-height: 34px;
  border-radius: 999px;
}

.optionStateRail-on {
  background: linear-gradient(180deg, #16a34a 0%, #15803d 100%);
}

.optionStateRail-off {
  background: linear-gradient(180deg, #ef4444 0%, #dc2626 100%);
}
</style>
